export const money = (amount, isCent = false) => {
  return `${window.currencySymbol}${(parseFloat(amount) / (isCent ? 100.0 : 1)).toLocaleString(undefined, { maximumFractionDigits: 2 })}`
}

export const formatPlayerTime = (seconds) => {
  const hrs = Math.floor(seconds / 3600)
  const mins = Math.floor((seconds - hrs * 3600) / 60)
  const secs = Math.round(seconds - hrs * 3600 - mins * 60)
  return `${hrs > 0 ? hrs + ':' : ''}${mins > 9 ? mins : '0' + mins}:${secs > 9 ? secs : '0' + secs}`
}

export const onlyUnique = (value, index, array) => {
  return array.indexOf(value) === index
}

export const toHTML = (content) => {
  let parsed = JSON.parse(content)
  let html = ''
  parsed.children?.forEach((node) => {
    switch (node.type) {
      case 'heading':
        html += `<h${node.level}>${node.children[0].value}</h${node.level}>`
        break
      case 'list':
        html += `<${node.listType === 'unordered' ? 'ul' : 'ol'}>`
        node.children.forEach((item) => {
          html += `<li>${item.children[0].value}</li>`
        })
        html += `<${node.listType === 'unordered' ? '/ul' : '/ol'}>`
        break
      case 'paragraph':
        html += `<p>`
        node.children.forEach((item) => {
          if (item.type === 'text' && item.bold) {
            html += `<strong>${item.value}</strong>` + ' '
          } else if (item.type === 'text' && item.italic) {
            html += `<em>${item.value}</em>` + ' '
          } else if (item.type === 'text') {
            html += `${item.value}` + ' '
          }
          if (item.type === 'link' && item.bold) {
            html += `<a href="${item.url}" target="${item.target}"><strong>${item.children[0].value}</strong></a>` + ' '
          } else if (item.type === 'link' && item.italic) {
            html += `<a href="${item.url}" target="${item.target}"><em>${item.children[0].value}</em></a>` + ' '
          } else if (item.type === 'link') {
            html += `<a href="${item.url}" target="${item.target}">${item.children[0].value}</a>` + ' '
          }
        })
        html += `</p>`
        break
    }
  })
  return html
}

export const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  )
}
export const initWishlist = () => {
  setTimeout(() => {
    if (typeof window._swat === 'undefined') {
      console.warn('SWAT is not loaded, skipping wishlist initialization')
      return
    }
    window._swat.initializeActionButtons('#product-grid', '.plp-wishlist-btn')
  }, 1500)
}

export const privatePrices = () => {
  if (typeof window.privateSale != 'undefined' && window.privateSale && window.showForLoggedInUsers) {
    document
      .querySelectorAll('[data-plp-regular-price]')
      .forEach((regularPrice) => regularPrice.classList.add('!hidden'))
    document
      .querySelectorAll('[data-plp-private-price]')
      .forEach((privatePrice) => privatePrice.classList.remove('!hidden'))
  }
}

export const scrollToSection = () => {
  const selector = `${location.hash}[data-hyperlink-section]`
  if (location.hash && document.querySelector(selector)) {
    const section = document.querySelector(selector)
    window.scrollTo({
      top: section.offsetTop - 100,
      left: 0,
      behavior: 'smooth',
    })
  }
}

export const makeid = (length) => {
  let result = ''
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  let counter = 0
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
    counter += 1
  }
  return result
}

export const trapFocus = (firstElement, lastElement) => {
  if(lastElement) {
    lastElement.addEventListener('keydown', (e) => {
      if (e.key === "Tab") {
        setTimeout(() => {
          firstElement.focus()
        }, 50)
      }
    })
  }
}